import { useState } from "react";
import { CaretUpDown, Check, LockSimple } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { COUNTRIES, countryName } from "@/lib/countries";
import { SANCTIONED_COUNTRIES } from "@/lib/constants";
import { cn } from "@/lib/utils";

// Searchable country picker (all ISO countries). value = ISO code or "". anyLabel adds a "no country" choice.
export default function CountryPicker({ id, value, onChange, testId = "country-picker", disabled, anyLabel, placeholder = "Pick a country", className, invalid }) {
  const [open, setOpen] = useState(false);
  const pick = (code) => { onChange(code); setOpen(false); };
  return (
    <Popover open={open} onOpenChange={setOpen} modal>
      <PopoverTrigger asChild>
        <Button id={id} type="button" variant="outline" role="combobox" aria-expanded={open} aria-invalid={invalid || undefined} disabled={disabled}
          className={cn("w-full justify-between bg-white font-normal", !value && "text-muted-foreground", className)} data-testid={testId}>
          <span className="truncate">{value ? `${countryName(value)} (${value})` : anyLabel || placeholder}</span>
          <CaretUpDown className="shrink-0 opacity-50" aria-hidden />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] min-w-[260px] p-0" align="start">
        <Command>
          <CommandInput placeholder="Search countries" data-testid={`${testId}-search`} />
          <CommandList>
            <CommandEmpty>No country found.</CommandEmpty>
            <CommandGroup>
              {anyLabel && <CommandItem value="__any" onSelect={() => pick("")} data-testid={`${testId}-option-any`}>{anyLabel}</CommandItem>}
              {COUNTRIES.map((c) => (
                <CommandItem key={c.code} value={`${c.name} ${c.code}`} onSelect={() => pick(c.code)} data-testid={`${testId}-option-${c.code}`}>
                  <Check className={cn(value === c.code ? "opacity-100" : "opacity-0")} aria-hidden />
                  <span className="flex-1">{c.name}</span>
                  {SANCTIONED_COUNTRIES[c.code] ? <LockSimple className="opacity-60" aria-label="Sanctioned" /> : <span className="cw-muted text-xs">{c.code}</span>}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
